
import { useState, useEffect } from "react"
import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TablePagination, TableBody } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import { useSelector, useDispatch } from "react-redux"
import { formatDinero } from "./../../../../utils/formatDinero"
import { FormatoFecha, FormatoFechaIso } from "./../../../../utils/FormatFecha"
import BackDrop from "../../../../global/BackDrop"
import { obtenerMovientosUSDAction } from "./../../../../ducks/finanzasDuck"
import PickerMod from "../../../../global/PickersMod"
import BCorte from "../FCorte"
import ButtonClienteDetalle from "../../../../global/ButtonClienteDetalle"
const columns = [
    { id: "referencia", minWidth: 50, align: "center", label: "Referencia" },
    { id: "montoMXN", minWidth: 50, align: "center", label: "Monto MXN" },
    { id: "tipoCambio", minWidth: 50, align: "center", label: "T.C.C." },
    { id: "montoUSD", minWidth: 50, align: "center", label: "Monto USD" },
    { id: "fechaPago", minWidth: 50, align: "center", label: "Fecha Pago" },
]

const useStyles = makeStyles({
    containerRoot: {
        marginTop: "25px",
        marginBottom: "25px"
    },
    containerRootButton: {
        marginTop: "25px",
        marginBottom: "25px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    root: {
        width: '100%',
        padding: '0'
    },
    container: {
        maxHeight: 440,
    },
})

const TMovimientos = () => {
    const movimientosUSD = useSelector(store => store.finanzas.movimientosCuenta)
    const rows = movimientosUSD?.MovimientosCuenta ?? []
    const classes = useStyles()
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [load, setLoad] = useState(false)
    const [selectDayInicio, setSelectedDateInicio] = useState(new Date());
    const [selectDayFinal, setSelectedDateFinal] = useState(new Date());
    const dispatch = useDispatch()

    useEffect(() => {
        setLoad(true)
        dispatch(obtenerMovientosUSDAction({ FechaInicio: FormatoFecha({ date: selectDayInicio, formato: "MMddyyyy" }), FechaFinal: FormatoFecha({ date: selectDayFinal, formato: "MMddyyyy" }) }))
            .then(Response => {
                setLoad(false)
            })
    }, [dispatch, selectDayInicio, selectDayFinal])

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }

    return (
        <div className={classes.containerRoot}>
            <div style={{ margin: "1% 0", display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
                <div style={{ margin: "1% 0", display: "flex", justifyContent: "flex-start", alignItems: "flex-end" }}>
                    <div>
                        <PickerMod
                            id="desde"
                            label="Desde"
                            selectedDate={selectDayInicio}
                            setSelectedDate={setSelectedDateInicio}
                            disablePast={false}
                            disableFuture={true}
                        />
                    </div>
                    <div >
                        <PickerMod
                            id="hasta"
                            label="Hasta"
                            selectedDate={selectDayFinal}
                            setSelectedDate={setSelectedDateFinal}
                            disablePast={false}
                            disableFuture={true}
                        />
                    </div>
                </div>

                <div>
                    <BCorte
                        disabled={(rows.length === 0) ? true : false}
                    />
                </div>
            </div>
            <Paper className={classes.root}>
                <TableContainer className={classes.container}>
                    <Table stickyHeader aria-label="sticky table">
                        <caption>
                            <div>Ingreso Total MXN: {formatDinero(movimientosUSD.TotalMXN)}</div>
                            <div>Total Movimientos: {rows.length}</div>
                        </caption>
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.id_movCuenta}>
                                        <TableCell align='center'>
                                            <ButtonClienteDetalle referencia={row.Referencia} />
                                        </TableCell>
                                        <TableCell align='center'>
                                            {`${formatDinero(row.monto)}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${formatDinero(row.tipoCambio)}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${formatDinero(row.monto / row.tipoCambio)}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${FormatoFechaIso({ date: row.Fecha, formato: "dd-MM-yyyy" })}`}
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>

            <BackDrop open={load} />
        </div>
    )
}
export default TMovimientos